/*
 * Helpers de ENTRADA de CNPJ da contraparte (Tela 5 — receita manual).
 *
 * Vivem num módulo próprio (não em `FormReceitaManual.tsx`) por causa do
 * `react-refresh/only-export-components`: um arquivo de componente deve exportar
 * SÓ componentes. Como estes helpers são exportados para teste unitário, isolá-los
 * aqui mantém o Fast Refresh são sem perder a cobertura.
 *
 * A UI exibe o CNPJ COM máscara (`00.000.000/0000-00`), mas o wire recebe os 14
 * dígitos PUROS (contrato BE selado). Toda a análise é por caractere — nenhum
 * `Number`/`parseInt` (não é money, mas mantemos o estilo string-based do projeto).
 */

/** Extrai apenas os dígitos de `texto` (descarta máscara, espaços, letras). */
export function apenasDigitosCnpj(texto: string): string {
  let saida = "";
  for (const caractere of texto) {
    if (caractere >= "0" && caractere <= "9") {
      saida += caractere;
    }
  }
  return saida;
}

/**
 * Formata os dígitos de um CNPJ progressivamente na máscara `00.000.000/0000-00`.
 *
 * Trabalha sobre os dígitos extraídos (até 14; excedente é descartado) e insere os
 * separadores apenas até onde houver dígito — assim o campo pode ser digitado da
 * esquerda para a direita sem "saltar" separadores adiante do cursor.
 */
export function formatarCnpjEntrada(texto: string): string {
  const digitos = apenasDigitosCnpj(texto).slice(0, 14);
  const n = digitos.length;
  if (n === 0) {
    return "";
  }

  let saida = digitos.slice(0, 2);
  if (n > 2) {
    saida += "." + digitos.slice(2, 5);
  }
  if (n > 5) {
    saida += "." + digitos.slice(5, 8);
  }
  if (n > 8) {
    saida += "/" + digitos.slice(8, 12);
  }
  if (n > 12) {
    saida += "-" + digitos.slice(12, 14);
  }
  return saida;
}
